import { render, staticRenderFns } from "./ReleaseReserve.vue?vue&type=template&id=f02880e6&"
import script from "./ReleaseReserve.vue?vue&type=script&lang=js&"
export * from "./ReleaseReserve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports